import React from "react";
import { connect } from "react-redux";
import { Strings } from "../../../Resources/Strings/i18n";
import { PATHS } from "../../../Constants";
import { Modal } from "../../CustomModal/Modal";
import Button from "@material-ui/core/Button";
import CommonUtils from "../../../Utils/CommonUtils";



function ErrorModal(props) {
  return (
    <div className="errorModal">
      <Modal
        show={props.showErrorModal}
        // handleClose={this.hideModal}
        parent={"exitsession"}
      >
        {
          <div>
            <div className="errorOtp">
              <div className="errorModal">
                <div className="modalTitle">
                  <p id="errorTitle">
                    <span id="errorText">{Strings("Error")}</span>
                    {Strings("ErrorOccurred")}
                  </p>
                </div>
                <div className="errorContainer">
                  <div className="errorContent">
                    <p>{props.errorMessage}</p>
                  </div>
                </div>
                <Button
                  className="errorBtn"
                  onClick={() => {
                    props.setShowErrorModal(false);

                    props.userInfo.id === ""
                      ? props.history && props.history.push(PATHS.LOGIN)
                      : props.history && props.history.push();
                  }}
                >
                  {props.errorMessage === String("ERROR_INVALID_AUTH_GRANT")
                    ? Strings("CloseAndLogin")
                    : Strings("Close")}
                </Button>
              </div>
            </div>
          </div>
        }
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
    return {
      userInfo: CommonUtils.getInvitedTokenInfo(state),
    };
  };
  
  export default connect(mapStateToProps)(ErrorModal);
  